interface SepLineProps {
  invisible?: boolean;
  className?: string;
}

export default function SepLine({ invisible, className = '' }: SepLineProps) {
  return (
    <div
      className={`sep-line ${className}`}
      style={invisible ? { visibility: 'hidden' } : undefined}
    >
      <div className="line-left" />
      <div className="line-right" />
      <div className="diamond" />
    </div>
  );
}
